<template>
	<div>
		<div class="card mb-4">
	        <div class="card-header">
				<div class="d-flex justify-content-between container-fluid">
		            <div class="text-muted fs-19">
		            	<strong>Destinos</strong>
		            </div>
		            <button
		            	@click="create()"
		            	class="btn btn-primary noprint">
		            	Novo
		            </button>
			    </div>
		    </div>
		    <div class="card-body">
		        <entrega-destino-table
		        	@show="show">
		        </entrega-destino-table>
		    </div>
		</div>
		<entrega-destino-create
			@reload="reload">
		</entrega-destino-create>
	</div>
</template>

<script>
	export default {
		methods: {
			create(){
				$('#create_entrega_destino').modal('show');
			},
			show(id){
				this.$router.push('/adm/entrega-destinos/show/'+id)
			},
			reload(){
				this.$emit('reload')
			}
		}
	}
</script>
